var map = {
	"./buttons.png": "yNQf",
	"./calendar.png": "uzkt",
	"./create.png": "pG4v",
	"./detail.png": "D0uu",
	"./export.png": "X1/4",
	"./import.png": "aZY4",
	"./info.png": "+MK8",
	"./list.png": "SGup",
	"./model.png": "r3iV",
	"./table.png": "0Y0q",
	"./train.png": "N3ed",
	"./variable.png": "AZF+"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "liDv";


//////////////////
// WEBPACK FOOTER
// ./src/assets/form-ui ^\.\/.*\.png$
// module id = liDv
// module chunks = 46